import type { Deposit, Deposits } from '@awaze/mfe-common.configs.brand'
import { getActiveDepositScheme } from '@awaze/mfe-common.configs.brand'
import type { CommonSite } from '@awaze/mfe-common.types-and-mocks.site-search-service'
import { useEffect, useState } from 'react'

interface UseGetActiveDepositSchemeArgs {
  deposits: Deposits
  propertyInfo: CommonSite | null
}

interface UseGetActiveDepositSchemeReturn {
  activeDeposit: Deposit | null
}

export const useGetActiveDepositScheme = ({
  deposits,
  propertyInfo,
}: UseGetActiveDepositSchemeArgs): UseGetActiveDepositSchemeReturn => {
  const [activeDeposit, setActiveDeposit] = useState<Deposit | null>(null)

  useEffect(() => {
    const dateToday = new Date()
    const isSite = propertyInfo?.cardinality === 'MULTI'

    const activeDeposit = propertyInfo?.startDate
      ? getActiveDepositScheme(
          deposits,
          dateToday,
          new Date(propertyInfo.startDate),
          isSite ? 0 : (propertyInfo?.property?.sleeps ?? 0),
          isSite ? (propertyInfo.priceFrom ?? 0) : (propertyInfo?.price ?? 0),
          isSite ? 'accom' : 'cottages',
        )
      : null

    setActiveDeposit(activeDeposit)
  }, [propertyInfo])

  return { activeDeposit }
}
